import type { AxiosResponse } from 'axios';
import axiosInstance from '../superadminAxiosInstance';

export class SuperadminAuthService {
	static async login({
		email,
		password,
	}: LoginRequest): Promise<LoginResponse> {
		const response: AxiosResponse<LoginApiResponse> =
			await axiosInstance.post('/superAdmin/login', {
				email,
				password,
			});

		return response.data.data;
	}

	static async loginAccount(
		accountID: number,
	): Promise<ChangeAccountResponse> {
		const response: AxiosResponse<ChangeAccountApiResponse> =
			await axiosInstance.post('/superAdmin/auth/loginToAccount', {
				accountID: accountID,
			});

		return response.data.data;
	}
}
